import {
    ScreenWidth,
    respondToAbove,
    screenInfo,
} from '@superbet-group/web.lib.vue-utilities';
import {
    ref,
    watch,
} from '@vue/composition-api';

export function useItemsPerCarouselSlide(numberofItemsPerScreenWidth: Partial<Record<ScreenWidth, number>>, defaultValue = 1) {
    const numberOfItemsPerSlide = ref<number>(defaultValue);
    watch(screenInfo, (_newValue) => {
        const itemsCount = Object.keys(numberofItemsPerScreenWidth).map((screenWidth) => {
            return respondToAbove(screenWidth as ScreenWidth)
                ? numberofItemsPerScreenWidth[screenWidth as ScreenWidth]
                : null;
        }).filter((itemCount): itemCount is number => itemCount !== undefined && itemCount !== null);
        if (itemsCount.length === 0) {
            numberOfItemsPerSlide.value = defaultValue;
        } else {
            numberOfItemsPerSlide.value = Math.max(...itemsCount);
        }
    }, { immediate: true });

    return {
        numberOfItemsPerSlide,
    };
}
